if (!customElements.get('main-collection-banner')) {
    class MainCollectionBanner extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.collectionDescription = this.querySelector(".collection-hero__description");
            this.textDescriptionContainer = this.querySelector(".text-description");
            this.originalElement = this.querySelector(".text-description p");
            this.displayElement = this.querySelector(".content-desc-new");

            this.labelViewMore = this.dataset.labelViewMore || "View more";
            this.labelViewLess = this.dataset.labelViewLess || "View less";

            const enableViewMore = this.collectionDescription?.dataset.enableViewMore === "true";

            if (enableViewMore) {
                this.renderViewMoreDescription();
                window.addEventListener("resize", () => this.renderViewMoreDescription());
            }
        }

        renderViewMoreDescription() {
            if (!this.originalElement || !this.displayElement) return;

            const originalHTML = this.originalElement.innerHTML.trim();
            
            // Check if <!--break--> comment exists in the container's HTML
            const containerHTML = this.textDescriptionContainer?.innerHTML || '';
            const breakComment = '<!--break-->';
            const hasBreakMarker = containerHTML.indexOf(breakComment) !== -1;
            
            if (hasBreakMarker) {
                this.renderWithCommentBreak(containerHTML, containerHTML.indexOf(breakComment), breakComment.length);
            } else {
                this.textDescriptionContainer.classList.remove('visibility-hidden');
                // Fall back to original line-based truncation
                // this.renderWithLineLimit(originalHTML);
            }
        }

        renderWithCommentBreak(originalHTML, breakIndex, commentLength) {
            // Split HTML at the comment position
            const beforeBreak = originalHTML.substring(0, breakIndex).trim();
            const afterBreak = originalHTML.substring(breakIndex + commentLength).trim();

            const suffixHTML = `<span class="ellipsis">... </span><span class="toggle-text">${this.labelViewMore}</span>`;

            // Helper to insert suffix inside the last element (e.g., <p>)
            const insertSuffixInsideElement = (html) => {
                const fragment = document.createElement("div");
                fragment.innerHTML = html;
                
                // Get the last element child (likely <p>) or use fragment if no children
                const lastElement = fragment.lastElementChild || fragment;
                
                // Parse suffix HTML and append its children
                const suffixContainer = document.createElement("div");
                suffixContainer.innerHTML = suffixHTML;
                
                // Append all suffix children to the last element
                while (suffixContainer.firstChild) {
                    lastElement.appendChild(suffixContainer.firstChild);
                }
                
                return fragment.innerHTML;
            };

            const renderTruncated = () => {
                const truncatedWithSuffix = insertSuffixInsideElement(beforeBreak);
                this.displayElement.innerHTML = truncatedWithSuffix;
                this.displayElement.querySelector(".toggle-text").addEventListener("click", renderFull);
            };

            const renderFull = () => {
                // Combine before and after break, removing the comment
                const fullHTML = beforeBreak + (afterBreak ? ' ' + afterBreak : '');
                const fullWithSuffix = insertSuffixInsideElement(fullHTML);
                // Replace the toggle text content
                const temp = document.createElement("div");
                temp.innerHTML = fullWithSuffix;
                const toggleText = temp.querySelector(".toggle-text");
                if (toggleText) {
                    toggleText.textContent = this.labelViewLess;
                }
                this.displayElement.innerHTML = temp.innerHTML;
                this.displayElement.querySelector(".toggle-text").addEventListener("click", renderTruncated);
            };

            renderTruncated();

            // Hide original
            this.querySelector(".text-description").style.display = "none";
            this.displayElement?.classList.remove('fixed-h');
            this.querySelector('.collection-hero__description')?.classList.remove('fixed-h');
        }

        renderWithLineLimit(originalHTML) {
            const computed = getComputedStyle(this.originalElement);
            let lineHeight = parseFloat(computed.lineHeight);

            if (isNaN(lineHeight)) {
                lineHeight = parseFloat(computed.fontSize) * 1.5;
            }

            const maxLines = 4;
            const maxHeight = lineHeight * maxLines;

            // Create measurer
            const measurer = document.createElement("div");
            Object.assign(measurer.style, {
                visibility: "hidden",
            });
            document.body.appendChild(measurer);

            const suffixHTML = `<span class="ellipsis">... </span><span class="toggle-text">${this.labelViewMore}</span>`;

            // Convert to plain text
            const temp = document.createElement("div");
            temp.innerHTML = originalHTML;
            const plainText = temp.textContent.trim();

            // Binary search
            let low = 0, high = plainText.length;
            let bestFitText = "";

            while (low < high) {
                const mid = Math.floor((low + high) / 2);
                let sliced = plainText.slice(0, mid);
                let words = sliced.split(/\s+/);
                if (words.length > 8) {
                    words = words.slice(0, words.length - 8);
                }
                sliced = words.join(" ");
                measurer.textContent = sliced + " " + this.labelViewMore;

                if (measurer.offsetHeight <= maxHeight) {
                    bestFitText = sliced;
                    low = mid + 1;
                } else {
                    high = mid;
                }
            }

            // Final HTML rebuild
            const safeWrapper = document.createElement("div");
            safeWrapper.innerHTML = originalHTML;
            const walker = document.createTreeWalker(safeWrapper, NodeFilter.SHOW_TEXT, null, false);

            let charCount = 0;
            const targetLength = bestFitText.length;

            while (walker.nextNode()) {
                const node = walker.currentNode;
                const text = node.textContent;
                if (charCount + text.length > targetLength) {
                    node.textContent = text.slice(0, targetLength - charCount);
                    while (node.nextSibling) {
                        node.parentNode.removeChild(node.nextSibling);
                    }
                    break;
                }
                charCount += text.length;
            }

            const finalTruncatedHTML = safeWrapper.innerHTML;

            const renderTruncated = () => {
                this.displayElement.innerHTML = finalTruncatedHTML + suffixHTML;
                this.displayElement.querySelector(".toggle-text").addEventListener("click", renderFull);
            };

            const renderFull = () => {
                this.displayElement.innerHTML = originalHTML + ' ' + `<span class="toggle-text">${this.labelViewLess}</span>`;
                this.displayElement.querySelector(".toggle-text").addEventListener("click", renderTruncated);
            };

            renderTruncated();

            // Hide original
            this.querySelector(".text-description").style.display = "none";
            measurer.remove();
            this.displayElement?.classList.remove('fixed-h');
            this.querySelector('.collection-hero__description')?.classList.remove('fixed-h');
        }
    }

    customElements.define('main-collection-banner', MainCollectionBanner);
}
